<div *ngIf='screenWidth > 767'>
  <div class="flex"></div>
  <div class="flex-444-px">
    <div class="bmw-profile-content">
      <div class="bmw-user-info-title">Subscription</div>
        <div class="bmw-forgot-password-note">
          <small>You do not have any active subscription, Please select one from below.</small>
        </div>
      <div style="margin-top: 40px">
        <h2 *ngIf="paypalLoad">Paypal button is loading</h2>
        <form ngNoForm action="javascript:void(0);" target="_top">
          <label>TIS Subscription Options</label>
          <select [ngModel]="selectedSubscriptionObj" (ngModelChange)="onChangeSubscription($event)" name="os0">
            <option [ngValue]="i" *ngFor="let i of tisSubscriptions">{{i.description}}</option>
          </select>

        </form>
        <br>
        <div id="paypal-checkout-btn"></div>
        </div>
    </div>
  </div>
  <div class="flex"></div>
</div>

<!-- Mobile HTML -->

<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <div class="visible-xs">
    <div class="bmw-profile-content bmw-xs">
      <div class="bmw-user-info-title">Subscription</div>
      <div class="bmw-forgot-password-note">
        <small>You do not have any active subscription, Please select one from below.</small>
      </div>
        <div style="margin-top: 40px">
          <h2 *ngIf="paypalLoad">Paypal button is loading</h2>
          <form ngNoForm action="javascript:void(0);" target="_top">
            <label>TIS Subscription Options</label>
            <select [ngModel]="selectedSubscriptionObj" (ngModelChange)="onChangeSubscription($event)" name="os0">
              <option [ngValue]="i" *ngFor="let i of tisSubscriptions">{{i.description}}</option>
            </select>
  
          </form>
          <br>
          <div id="paypal-checkout-btn"></div>
  
        </div>

      </div>
    </div>
    </div>
<!--</div>-->